<template>
  <svg
    width="12"
    height="8"
    viewBox="0 0 12 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.53685 0.667969L5.99935 5.12075L10.4618 0.667969L11.8327 2.0388L5.99935 7.87214L0.166016 2.0388L1.53685 0.667969Z"
      fill="#5E6A79"
    />
  </svg>
</template>
<script>
export default {
  name: "IconDown",
};
</script>

<style></style>
